import { PrimaryColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { canHover, canTouch } from '@picsart/design-system/foundation/styleHelpers';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    margin: {
      marginTop: Spacings.s56,
    },
    title: {
      marginBottom: Spacings.s56,
      fontSize: FontSizes.s30,
      textAlign: 'center',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        marginBottom: Spacings.s24,
        fontSize: FontSizes.s24,
      },
    },
    titleSkeleton: {
      marginBottom: Spacings.s56,
      height: Spacings.s32,
      textAlign: 'center',
      maxWidth: '30%',
      margin: 'auto',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        marginBottom: Spacings.s24,
        height: Spacings.s24,
      },
    },

    textSkeleton: {
      height: 20,
      marginBottom: Spacings.s16,
      maxWidth: '30%',
      margin: 'auto',
    },
    text: {
      marginBottom: Spacings.s8,
      fontSize: FontSizes.s20,
      textAlign: 'center',
      color: TextColors.base,

      '& > span': {
        fontWeight: FontWeights.bold,
        color: TextColors.base,
      },

      [mediaQuery(1023)]: {
        fontSize: FontSizes.s16,
      },
      '& > a': {
        color: PrimaryColors.base.default,

        [canHover]: {
          '&:hover': {
            color: PrimaryColors.base.action,
          },
        },

        [canTouch]: {
          '&:active': {
            color: PrimaryColors.base.action,
          },
        },
      },
    },
  }),
  { name: 'brands-texts' },
);

export default useStyles;
